import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateSlot = createAsyncThunk('updateSlot', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + `slot`,
            data: {
                "id": data?.values?.id,
                "slot_name": data?.values?.slotName,
                "max_normal_seat": Number(data?.values?.maxNormalSeat),
                "max_premium_seat": Number(data?.values?.maxPremiumSeat),
                "slotPrice": data?.values?.slotPrice?.map((item) => ({
                    "slot_type": item?.slotType,
                    "normal_seat_price": Number(item?.normalSeatPrice),
                    "premium_seat_price": Number(item?.premiumSeatPrice),
                    "status": item?.status || "Active",
                }))
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
